import { Slide } from '@/types/slide';
import { gql } from '@apollo/client';
import { GetLessonResponse } from '../useLesson/gql';

export interface GetLessonsCountResponse {
    lessonsCount: number;
}

export const GET_LESSONS_COUNT = gql`
    query LessonsCount($where: LessonWhereInput) {
        lessonsCount(where: $where)
    }
`;

export interface GetLessonsVariables {
    id?: { equals: string };
}

export interface GetLessonsResponse {
    lessons: GetLessonResponse['lesson'][];
}

export const GET_LESSONS = gql`
    query Lessons($skip: Int, $take: Int, $where: LessonWhereInput) {
        lessons(skip: $skip, take: $take, where: $where, orderBy: [{ dateUpdated: desc }]) {
            id
            latestLessonVersion {
                lessonName
            }
            latestLessonDraft {
                id
                lessonName
                dateUpdated
                published
            }
            folder {
                id
                sharesCount
            }
            shareWithPublic
            sharesCount
            shares {
                id
                user {
                    name
                    email
                }
                email
            }
            teacher {
                id
                user {
                    name
                    email
                }
            }
        }
    }
`;

export interface GetLessonSlidesResponse {
    slides: (Slide & { lessonVersion: { id: string } })[];
}

export const GET_LESSON_SLIDES = gql`
    query Slides($where: SlideWhereInput!) {
        slides(where: $where, orderBy: { sort: asc }) {
            id
            data
            lessonVersion {
                id
            }
        }
    }
`;

export interface CreateLessonVariables {
    lessonCreateInput: object;
}

export interface CreateLessonResponse {
    createLesson: GetLessonResponse['lesson'];
}

export const CREATE_LESSON = gql`
    mutation CreateLesson($lessonCreateInput: LessonCreateInput!) {
        createLesson(data: $lessonCreateInput) {
            id
            latestLessonVersion {
                lessonName
            }
            latestLessonDraft {
                id
                lessonName
                dateUpdated
                published
            }
            shareWithPublic
            sharesCount
            shares {
                id
                user {
                    name
                    email
                }
                email
            }
            teacher {
                id
                user {
                    name
                    email
                }
            }
        }
    }
`;

export interface UpdateLessonVersionVariables {
    where: {
        id: string;
    };
    data: {
        lessonName?: string;
    };
}

export interface UpdateLessonVersionResponse {
    updateLessonVersion: {
        id: string;
        lessonName: string;
    };
}

export const UPDATE_LESSON_VERSION = gql`
    mutation UpdateLesson($where: LessonVersionWhereUniqueInput!, $data: LessonVersionUpdateInput!) {
        updateLessonVersion(where: $where, data: $data) {
            id
            lessonName
        }
    }
`;

export interface UpdateLessonVariables {
    data: {
        where: {
            id: string;
        };
        data: {
            archived?: boolean;
            folder?: {
                connect?: {
                    id: string;
                };
                disconnect?: boolean;
            };
        };
    }[];
}

export const UPDATE_LESSONS = gql`
    mutation UpdateLessons($data: [LessonUpdateArgs!]!) {
        updateLessons(data: $data) {
            id
        }
    }
`;

export interface GetLessonsByFoldersResponse {
    lessons: {
        id: string;
    }[];
}

export const GET_LESSONS_BY_FOLDERS = gql`
    query Lessons($where: LessonWhereInput) {
        lessons(where: $where) {
            id
        }
    }
`;
